import qs from 'qs';
import { network } from 'services/network';

import { QueryParams } from 'api/queries/getRiskRegister.query';

export const getRiskRegister = (params: QueryParams) => {
    const querystring = qs.stringify(params, { addQueryPrefix: true, skipNulls: true });

    const url = `api/bo/getRiskRegister${querystring}`;

    return network.get(url).then((response) => {
        return response.data;
    });
};
